<template>
	<div class="modal fade" :id="modal.selector" tabindex="-1" role="dialog" aria-hidden="true">
		<div class="modal-dialog" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="btn-toolbar pull-right" role="toolbar">
						<div class="btn-group" role="group" aria-label="...">
							<button type="button" class="close" data-dismiss="modal" aria-label="Close">
								<span aria-hidden="true">&times;</span>
							</button>
						</div>
					</div>
					<h4  class="modal-title">Configuración</h4>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-6">
							<div v-if="taxes" class="form-group">
								<select @change="changeTax" :disabled="loading" v-model="data.tax_id" v-if="taxes.length" class="form-control">
									<option :value="null">Ninguno</option>
									<option v-for="tax in taxes" :value="tax.id">{{ tax.name }}</option>
								</select>
							</div>
						</div>
						<div class="col-md-6">
							<div v-if="currencies" class="form-group">
								<select @change="changeCurrency" :disabled="loading" v-model="data.currency_id" v-if="currencies.length" class="form-control">
									<option v-for="currency in currencies" :value="currency.id">{{ currency.name }}</option>
								</select>
							</div>
						</div>
					</div>
					<div class="row">
						<div class="col-md-6">
							<template v-if="paymentMethods">
								<div class="input-group">
									<select @change="changePaymentMethod" v-model="data.payment_method_id" class="form-control">
										<option :value="null">Seleccionar métodod de pago</option>
										<option v-for="payment in paymentMethods" :value="payment.id">
											{{ payment.name }}
										</option>
									</select>
									<template v-if="data.payment_method">
										<template v-if="data.payment_method.collection_accounts">
											<template v-if="data.payment_method.collection_accounts.length">
												<template v-if="data.payment_method.collection_accounts.length > 1">
													<span class="input-group-btn">
														<button @click="collectionAccounts" class="btn btn-default" type="button">
															<i class="fa fa-university" aria-hidden="true"></i>
														</button>
													</span>
												</template>
											</template>
										</template>
									</template>
								</div>
							</template>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<button type="button" class="btn btn-default" data-dismiss="modal">Cerrar</button>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import swal from 'sweetalert2'
	export default {
		props: ['user', 'isAuth', 'data'],
		components: {
			
		},
		data () {
			return {
				modal: {
					selector: 'modal-settings-invoice'
				},

				loading: false,
				taxes: false,
				currencies: false,
				paymentMethods: false,
			}
		},
		created() {
			this.getTaxes()
			this.getCurrencies()
			this.getPayMentMethods()
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			open() {
				var modal = $('#'+this.modal.selector)
				modal.modal('show')
			},
			close () {
				var modal = $('#'+this.modal.selector)
				modal.modal('hide')
			},
			//--
			getTaxes: function() {
				this.$http.get('admin/management/taxes')
					.then(response => {
						this.taxes = response.body
					})
			},
			getCurrencies: function() {
				this.$http.get('admin/cms/currencies')
					.then(response => {
						this.currencies = response.body
					})
			},
			getPayMentMethods() {
				this.$http.get('admin/management/payment/methods')
				.then(response => {
					this.paymentMethods = response.body
				}).catch(function(response) {
					console.log(response)
				})
			},
			changeTax(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.tax_id) {
					var api = 'admin/management/invoices/' + this.data.id + '/change/tax/' + this.data.tax_id
				} else {
					var api ='admin/management/invoices/' + this.data.id + '/change/tax'
				}
				this.$http.get(api)
					.then(response => {
						select.removeAttribute('disabled')
						this.loading = false
						this.$emit('reload')
					})
			},
			changeCurrency(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.currency_id) {
					this.$http.get('admin/management/invoices/' + this.data.id + '/change/currency/' + this.data.currency_id)
						.then(response => {
							this.loading = false
							select.removeAttribute('disabled')
							this.$emit('reload')
						}).catch(response => {
							this.loading = false
							select.removeAttribute('disabled')
							if(response.status == 409) {
								swal({
									title: response.statusText,
									text: response.body,
									type: 'warning',
								})
							}
							this.$emit('reload')
						})
				}
			},
			changePaymentMethod(el) {
				var select = el.currentTarget
				select.setAttribute('disabled', true)
				this.loading = true
				if(this.data.payment_method_id) {
					var api = 'admin/management/invoices/' + this.data.id + '/change/payment/method/' + this.data.payment_method_id
				} else {
					var api = 'admin/management/invoices/' + this.data.id + '/change/payment/method'
				}
				this.$http.get(api)
				.then(response => {
					this.loading = false
					select.removeAttribute('disabled')
					this.$emit('reload')
				}).catch(response => {
					this.loading = false
					select.removeAttribute('disabled')
					if(response.status == 409) {
						swal({
							title: response.statusText,
							text: response.body,
							type: 'warning',
						})
					}
					this.$emit('reload')
				})
			},
			collectionAccounts() {
				this.close()
				this.$emit('openCollectionAccounts')
			}
		},
	}
</script>


// WEBPACK FOOTER //
// src/components/management/invoices/views/Settings.vue